import axios from 'axios';
export {brandActions};

axios.defaults.withCredentials = true

function brandActions() {
    const baseUrl = ``;
    const tenantVal = `${process.env.REACT_APP_TENANT}`;
  
    return {
    
        getBrandQueryParams,
        exportData,

    }


    async function getBrandQueryParams(tenant: string, pageNumber:number,pageSize:number,description?:string,code?:string,){      
        return   axios.get(`${baseUrl}/masterdatavehicle/brand`,{
                params:
                
                {   tenant: tenant,
                    pageNumber:pageNumber,
                    pageSize:pageSize,
                    description:description,
                    code:code,
                }
            })
    }

    async function exportData(tenant:string,description?:string,code?:number){ 
        const params=
        {  
            tenant: tenant,
            description:description,
            code:code,
        }  
        return    axios.get(`${baseUrl}/masterdatavehicle/brand/excel`,
               { params:params,
                responseType: 'arraybuffer',
             })
    }
}
